import { render } from "./MainDailyReport.vue?vue&type=template&id=8e57df6e"
import script from "./MainDailyReport.vue?vue&type=script&lang=js"
export * from "./MainDailyReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__